import * as React from "react"

const PageTitle = ( props ) => (
    <div className="page-title" id={props.page}>
        <h1>{props.title}</h1>
    </div>    
)
export default PageTitle
